import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { verify } from "crypto";
import { boolean, string } from "yup";
import { getNewBlRequestAttConf, getNewBlRequestDetails } from "./NewBlRequestActions";
import { addDemurrage, getAttachmentsOnly, getDemurrage, getDemurrageView } from "../dashboard/actions/instruction";


interface IDemurrageForm {
  senderEmail: string | null;
  intendedDate: string | null;
  truckerCode: string | null;
  country: string | null;
  status: string | null;
  requestedPartnerName: string | null;
}





interface IDemurrageList {
  list: any[];
  next: string | null;
  previous: string | null;
}

interface IDemurrageDocAttachmentList {
  list: any[];
  next: string | null;
  previous: string | null;
}

export interface IDemurrageDetails {

  data: IDemurrageList;
  
  isDemurrageDetailsLoading: boolean;
  dataLoading: boolean;
  
  attData: IDemurrageDocAttachmentList;
  docList: any[] | null;
  dropdownDocList: any[] | null;  //  attachment configs for hidden documents
  selectedAttachmentName: any;
  selectedAttachmentBytrr: any;
  selectedAttachmentFilePath: any;
  selectedDocId: any;
  selectedFileServerPath: any;

    selectedLinerAttachmentName: any;
  selectedLinerAttachmentFilePath: any;
  selectedLinerDocId: any;
  selectedLinerFileServerPath: any;
  linerAttachmentId: any;



}

const initialState: IDemurrageDetails = {
  data: {
    list: [],
    next: null,
    previous: null,
  },

  attData: {
    list: [],
    next: null,
    previous: null,
  },

  docList: null,
  dropdownDocList: null,


  dataLoading: true,
  isDemurrageDetailsLoading: false,

  selectedAttachmentName: {},
  selectedAttachmentBytrr: {},
  selectedDocId: {},

  selectedAttachmentFilePath: {},

  selectedFileServerPath: {},

  selectedLinerAttachmentFilePath: null,
  selectedLinerAttachmentName: null,
  selectedLinerDocId: {},
  selectedLinerFileServerPath: [],
  linerAttachmentId: null
};

export const NewBlRequestSlice = createSlice({
  name: "NewBlRequestSlice",
  initialState,
  reducers: {
    updateDemurrageList: (state, action: PayloadAction<IDemurrageList>) => {
      state.data = action.payload;
    },

    updateSelectedAttachmentName: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentName = action.payload;
    },
   
    updateSelectedAttachmentBytrr: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentBytrr = action.payload;
    },
  
    updateSelectedDocId: (state, action: PayloadAction<any>) => {
      state.selectedDocId = action.payload;
    },
   
    updateAdttamentData: (state, action: PayloadAction<any>) => {
      state.attData.list = action.payload;
    },


    updateSelectedAttachmentFilePath: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentFilePath = action.payload;
    },


      updateSelectedLinerAttachmentName: (state, action: PayloadAction<any>) => {
      state.selectedLinerAttachmentName = action.payload;
    },    

     updateSelectedLinerDocId: (state, action: PayloadAction<any>) => {
      state.selectedLinerDocId = action.payload;
    },
 updateSelectedLinerAttachmentFilePath: (state, action: PayloadAction<any>) => {
      state.selectedLinerAttachmentFilePath = action.payload;
    },
       updateSelectedLinerFileServerPath:(state, action:PayloadAction<any>)=>{
      state.selectedLinerFileServerPath = action.payload
    },
    clearSelectedFileServerPath: (state) => { state.selectedFileServerPath = {} },
   

   


    clearFields: (state) => {
      // state.docList = null;
      state.dropdownDocList = null;
      state.selectedAttachmentName = {};
      state.selectedAttachmentFilePath = {};
      state.selectedFileServerPath = {};
    },

  

    updateSelectedFileServerPath: (state, action: PayloadAction<any>) => {
      state.selectedFileServerPath = action.payload
    },

       updateLinerAttachmentId: (state, action: PayloadAction<any>) => {
      state.linerAttachmentId = action.payload;
    }, 



    addDocument: (state, action) => {

      if (!state.dropdownDocList || state.dropdownDocList.length === 0) return;

      const docListKey = 'docList';
      const attDataKey = 'attData';
      // const docList = state[docListKey];
      // const attData = state[attDataKey];


      const rowNumber = crypto.randomUUID()
      const newDoc = { rowNumber: rowNumber, ...state.dropdownDocList[0] };

      state[docListKey] = [...(state[docListKey] ?? []), newDoc]

      state[attDataKey].list = [
        ...state[attDataKey].list,
        {
          rowNumber: newDoc.rowNumber,
          attachmentId: null,
          docId: newDoc.id,
          fileName: "",
          verify: false,
          actionBy: "",
          actionOn: "",
          m: newDoc.m,
          isDropDownDoc: true
        }
      ]
    },
    removeDocument: (state, action) => {
      const { rowNumber } = action.payload;
      const rowNumberToRemove = rowNumber;

      const docListKey = 'docList';
      const attDataKey = 'attData';

      state[docListKey] = (state[docListKey] ?? []).filter(doc => doc.rowNumber !== rowNumberToRemove);

      state[attDataKey].list = (state[attDataKey].list ?? []).filter(att => att.rowNumber !== rowNumberToRemove);

      const { [rowNumberToRemove]: removedName, ...restSelectedAttachmentName } = state.selectedAttachmentName ?? {};
      state.selectedAttachmentName = Object.keys(restSelectedAttachmentName).length > 0 ?
        restSelectedAttachmentName : {};

      const { [rowNumberToRemove]: removedFilePath, ...restSelectedAttachmentFilePath } = state.selectedAttachmentFilePath ?? {};
      state.selectedAttachmentFilePath = Object.keys(restSelectedAttachmentFilePath).length > 0 ? restSelectedAttachmentFilePath : {};

      const { [rowNumberToRemove]: removedServerPath, ...restSelectedFileServerPath } = state.selectedFileServerPath ?? {};
      state.selectedFileServerPath = Object.keys(restSelectedFileServerPath).length > 0 ?
        restSelectedFileServerPath : {};

    },
    updateListByRowNumber: (state, action) => { // only for dropdown change
      const { rowNumber, updatedFields, isExtension } = action.payload;

      const docListKey = 'docList';
      const attDataKey = 'attData';

      const docList = state[docListKey];
      if (!docList) return;
      // Find the index of the doc to update
      const docListIndex = (docList ?? []).findIndex(doc => doc.rowNumber === rowNumber);

      if (docListIndex !== -1) {
        // docListIndex the found doc by merging the updated fields
        docList[docListIndex] = {
          ...docList[docListIndex],
          ...updatedFields
        };
      }

      if (state[attDataKey]?.list) {

        const attIndex = (state[attDataKey].list ?? []).findIndex(att => att.rowNumber === rowNumber);
        if (attIndex !== -1) {
          state[attDataKey].list[attIndex] = {
            ...state[attDataKey].list[attIndex],
            docId: updatedFields.id,
          };
        }
      }
    }

  
    //---- new ends here ----
  },
  extraReducers: (builder) => {

    builder.addCase(getNewBlRequestAttConf.fulfilled, (state, action) => {

      const updatedDocList = action?.payload?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))?.map?.((i: any) => ({
        rowNumber: crypto.randomUUID(),
        id: i?.docId,
        name: i.docName,
        m: i.isMandatory == 'Y',
        // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
      }))

      const updatedExtensionDocList = action?.payload?.filter((i: any) => (i.isMandatory == "E"))?.map?.((i: any) => ({
        rowNumber: crypto.randomUUID(),
        id: i?.docId,
        name: i.docName,
        m: true,
        isDOExtensionFile: true
        // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
      }))

      const dropdownOptions = action?.payload?.filter((i: any) => (i.isMandatory == "H"))?.map?.((i: any) => ({
        id: i?.docId,
        name: i.docName,
        m: true,
        isDropDownDoc: true
      }))

      state.dropdownDocList = dropdownOptions ?? []

      state.docList = updatedDocList ?? []


      state.attData.list = (updatedDocList ?? [])?.map((x: any) => ({
        rowNumber: x.rowNumber,
        attachmentId: null,
        docId: x.id,
        fileName: "",
        verify: false,
        actionBy: "",
        actionOn: "",
        m: x.m,
        ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
        // isDropDownDoc: x?.isDropDownDoc
      }))

    });

 

    builder.addCase(getNewBlRequestDetails.pending, (state, action) => {

      state.dataLoading = true;

    })
    builder.addCase(getNewBlRequestDetails.fulfilled, (state, action) => {
      state.dataLoading = false;
      console.log(action.payload, "action.payload67")
      state.dropdownDocList = action.payload?.dropdownDocList ?? []
      state.docList = action.payload?.updatedDocListData ?? []
      state.attData.list = action?.payload?.attList || [];

      const attList = action?.payload?.attList ?? [];
       if (Array.isArray(attList) && attList?.length > 0) {
        let tempSelectedAttachmentName = {} as any;
        let tempSelectedAttachmentFilePath = {} as any;
        for (var i = 0; i < attList?.length; i++) {
          const key = attList?.[i]?.attachmentId ?? attList?.[i]?.rowNumber ?? null;
          // tempSelectedAttachmentName = {
          //   ...tempSelectedAttachmentName,
          //   [key]: {
          //     name: attList?.[i]?.fileName || null,
          //   },
          // };
          tempSelectedAttachmentName[key] = {
              name: attList?.[i]?.fileName || null,
          };
          // tempSelectedAttachmentFilePath = {
          //   ...tempSelectedAttachmentFilePath,
          //   [key]:
          //     attList?.[i]?.filePath || null,
          // };
          tempSelectedAttachmentFilePath[key] = attList?.[i]?.filePath || null
        }
        state.selectedAttachmentName = tempSelectedAttachmentName
        state.selectedAttachmentFilePath = tempSelectedAttachmentFilePath
 
     
      }

        state.selectedLinerAttachmentFilePath = action?.payload?.linerDocuments?.[0]?.filePath;
      state.selectedLinerAttachmentName = action?.payload?.linerDocuments?.[0]?.fileName;
      state.linerAttachmentId = action?.payload?.linerDocuments?.[0]?.attachmentId;

      
    })
  },
});
export const {
  updateDemurrageList,
  updateSelectedAttachmentBytrr,
  updateSelectedAttachmentName,
  updateSelectedDocId,
  updateAdttamentData,
  updateSelectedAttachmentFilePath,
  updateSelectedFileServerPath,
  clearSelectedFileServerPath,
  updateSelectedLinerFileServerPath,
  addDocument,
  removeDocument,
  clearFields,
  updateSelectedLinerDocId,
  updateSelectedLinerAttachmentName,
    updateSelectedLinerAttachmentFilePath,
  updateListByRowNumber,
  updateLinerAttachmentId
} = NewBlRequestSlice.actions;

export default NewBlRequestSlice.reducer;
